import s from "./style.module.scss";
import { CloseButton } from "@/components/CloseButton/CloseButton";
import { UIButton } from "@/components/UIButton/UIButton";
import Smile from "@/assets/smile.svg?react";
import Check from "@/assets/check.svg?react";
import Warning from "@/assets/warning.svg?react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Description } from "@/components/Description/Description";

interface StatusModalProps {
  closeModal: () => void;
  status: Status;
}

export type Status = "arbitrage";
// | "declined"
// | "cancelled"
// | "accepted"
// | "work_finished"
// | "completed"
// | "fix";

const statusConfig = {
  // accepted: {
  //   title: "Фрилансер подтвердил \n заказ и уже начал работу",
  //   Icon: Smile,
  //   button: "Отлично",
  //   description: "",
  // },
  // work_finished: {
  //   title: "Фрилансер сообщает \n о готовности заказа",
  //   Icon: Check,
  //   button: "Отлично",
  //   description: "",
  // },
  // completed: {
  //   title: "Вы завершили \n сотрудничество",
  //   Icon: Check,
  //   button: "Отлично",
  //   description: "",
  // },

  // declined: {
  //   title: "Фрилансер отказался \n от заказа",
  //   Icon: Warning,
  //   button: "Вернуться в каталог",
  //   description: "",
  // },
  // cancelled: {
  //   title: "Заказ был отменен",
  //   Icon: Warning,
  //   button: "Вернуться в каталог",
  //   description: "",
  // },
  // fix: {
  //   title: "Заказ был отправлен \n на доработку",
  //   Icon: Warning,
  //   button: "Вернуться в каталог",
  //   description: "",
  // },
  arbitrage: {
    title: "Арбитраж",
    Icon: Check,
    description:
      "Поможет решить спорную ситуацию или технически закрыть заказ (например, разделить бюджет)",
    button: "Хорошо",
  },
};
export const StatusModal = (props: StatusModalProps) => {
  const { closeModal, status } = props;
  const [cache, setCache] = useState(status);

  useEffect(() => {
    if (status) {
      setCache(status);
    }
  }, [status]);
  const { title, Icon, button, description } = statusConfig[cache];
  const navigate = useNavigate();

  return (
    <div className={s.wrapper}>
      <div className={s.line}></div>
      <CloseButton onClose={closeModal} />
      <Icon className={s.icons} />
      <p className={s.title}>{title}</p>
      <p className={s.description}>{description}</p>
      <UIButton
        fontType={"primary-2"}
        className={s.button}
        color="light-green-2"
        onClick={() => {
          if (["accepted", "work_finished", "completed"].includes(status)) {
            closeModal();
          } else {
            navigate("/");
            closeModal();
          }
        }}
        size="thin"
      >
        {button}
      </UIButton>
    </div>
  );
};
